import {
  AfterViewInit,
  Component,
  HostListener,
  Renderer2,
  OnChanges,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { CoreService } from "./shared/services/core.service";
import { TagManagerService } from "./shared/services/tag-manager.service";
import { Subscription, Observable } from "rxjs";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { Basket } from "./shared/models/baske.model";
import { filter } from "rxjs/operators";
import { select, Store } from "@ngrx/store";
import { IAppState } from "./store/states/app.state";
import { selectMerchant } from "./store/selectors/merchant.selector";
import { GetMerchant } from "./store/actions/merchant.actions";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";


import { OnDestroy, OnInit } from "@angular/core";
import { fromEvent } from "rxjs";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})

// Main component of the application
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  onlineEvent!: Observable<Event>;
  offlineEvent!: Observable<Event>;

  subscriptions: Subscription[] = [];

  connectionStatusMessage!: string;
  connectionStatus!: string;

  title = "toodle webapp";
  showLoader: boolean = false;
  Splashscreen: boolean = true;
  currentBasket$!: Observable<any>;
  Merchant$ = this._store.pipe(select(selectMerchant));
  basket$ = this.coreService.basket$;
  test$!: Observable<number>;
  currentBasket!: Basket;
  public Home: Boolean = false;
  public Product: Boolean = false;
  public Basket: Boolean = false;
  public PaymentScreen: Boolean = false;
  isMultiOutlet = false;
  showHeader = true;
  hideHeaderForOutletHome = false;

  public RouetChangeDetect: Boolean = false;
  constructor(
    private coreService: CoreService,
    private _store: Store<IAppState>,
    private renderer: Renderer2,
    private router: Router,
    private cds: ChangeDetectorRef,
    private tagManager: TagManagerService,
    private swUpdate: SwUpdate,
  ) {
    // Dispatch an action to get Merchant data with ignore_notification_id only for multioutlet home screen
    const ignoreNotificationId = CoreService.MultiOutlet
      ? this.getIgnoreNotificationIdsForHome()
      : "";
    this._store.dispatch(
      new GetMerchant(
        this.coreService.getmerchantReqData("", "", ignoreNotificationId),
      ),
    );
  }

  ngAfterViewInit() {
    // Lifecycle hook called after the view has been initialized
    // Hide the home loader element after the view is rendered
    let loader = this.renderer.selectRootElement("#Homeloader");
    if (loader) this.renderer.setStyle(loader, "display", "none");

    this.Merchant$?.subscribe((data) => {
      // Initialize GTM with retailer-provided ID if present
      // console.log("d.google_tag_manager_id" + data.google_tag_manager_id);
      // console.log("data?.multi_outlet" + JSON.stringify(data));
      // console.log(
      //   "data?.webapp_settings?.home_screen_layout" +
      //     data?.webapp_settings?.home_screen_layout,
      // );
      // console.log("YASIN" + this?.router?.url?.split("?")[0]);
      const currentUrl = this?.router?.url?.split("?")[0];

      this.updateHideHeaderForOutletHome(data);

      try {
        const d: any = data as any;
        const gtmId =
          (d &&
            (d.google_tag_manager_id ||
              d?.webapp_settings?.google_tag_manager_id)) ||
          null;
        if (gtmId && gtmId !== "GTM-MX5VHBNV") {
          this.tagManager.initWithId(gtmId);
          // console.log("Merchant GTM injected:", gtmId);
        } else {
          // console.log(
          //   "No merchant GTM or master GTM detected, skipping injection",
          // );
        }
        // console.log("GTM DONE" + gtmId);
      } catch {
        // console.log("GTM ERROR");
      }

      var fontTheme;
      if (data?.multi_outlet) {
        this.isMultiOutlet = true;
        if (this.coreService.stcurrentUrl == "/") {
          this.showHeader = false;
        }
        fontTheme = data?.font_theme_selection;
      } else {
        fontTheme = data?.webapp_settings?.font_theme_selection;
      }

      if (fontTheme) {
        this.applyFontTheme(fontTheme);
      } else {
        this.applyFontTheme("");
      }
    });
  }

  async ngOnInit() {
    // this.activateAppUpdates();
    // Initialize Google Tag Manager (fetches GTM ID by subdomain and injects scripts)
    // this.tagManager.init();
    this.tryOpenCenteredPopup();

    // Lifecycle hook called after component initialization
    this.getRouteChange();
    // Subscribe to showLoader value from CoreService to show/hide loader
    this.coreService.showLoader.subscribe((data) => {
      this.showLoader = data;
      this.cds.detectChanges();
    });

    // Restore basket data from session storage if available
    const basketData = sessionStorage.getItem("mybasket");
    if (basketData) this.coreService.basketSubject.next(JSON.parse(basketData));

    /**
     * Get the online/offline status from browser window
     */
    this.onlineEvent = fromEvent(window, "online");
    this.offlineEvent = fromEvent(window, "offline");

    // Subscribe to online and offline events
    this.subscriptions.push(
      this.onlineEvent.subscribe((e) => {
        this.connectionStatusMessage = "Back to online";
        this.connectionStatus = "online";
        // console.log("you are back to Online...");
      }),
    );

    this.subscriptions.push(
      this.offlineEvent.subscribe((e) => {
        this.connectionStatusMessage =
          "Connection lost! You are not connected to internet";
        this.connectionStatus = "offline";
        // console.log("oops you are Offline...");
      }),
    );
  }

  private activateAppUpdates() {
    // Add PWA manifest files to service worker caching when PWA caching is enabled.
    // Reference: "/*.js", "/manifest.json", "/manifest.webmanifest"

    if (!this.swUpdate.isEnabled) return;

    this.subscriptions.push(
      this.swUpdate.versionUpdates
        .pipe(
          filter(
            (event): event is VersionReadyEvent =>
              event.type === "VERSION_READY",
          ),
        )
        .subscribe(() => {
          this.swUpdate.activateUpdate().then(() => document.location.reload());
        }),
    );

    this.swUpdate.checkForUpdate().catch((error) => {
      console.error("Service worker update check failed", error);
    });
  }

  loadGoogleFont(fontName: string) {
    const linkId = `font-${fontName.replace(/\s+/g, "-")}`;
    if (document.getElementById(linkId)) return; // prevent duplicate loading

    const link = document.createElement("link");
    link.id = linkId;
    link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(
      /\s+/g,
      "+",
    )}:wght@300;400;500;600;700;800&display=swap`;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  applyFontTheme(themeName: string) {
    const styleId = "dynamic-font-style";
    document.getElementById(styleId)?.remove();

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.id = styleId;

    let css = "";
    let fontsToLoad: string[] = [];

    switch (themeName) {
      case "Modern Luxe":
        fontsToLoad = ["Raleway"];
        css = `
          .page-header, .button { font-family: 'Raleway'; font-weight: 700; }
          #app { font-family: 'Raleway'; font-weight: 400; }
          .modal-header { font-family: 'Raleway'; font-weight: 800; }
          .modal-body { font-family: 'Raleway'; font-weight: 500; }
          .modal-footer { font-family: 'Raleway'; font-weight: 400; }
          .about-section { font-family: 'Raleway'; font-weight: 400; font-size: 14px; }
        `;
        break;

      case "Minimal Chic":
        fontsToLoad = ["Poppins", "Lato"];
        css = `
          .page-header, .button { font-family: 'Poppins'; font-weight: 600; }
          #app { font-family: 'Lato'; font-weight: 400; }
          .modal-header { font-family: 'Poppins'; font-weight: 700; }
          .modal-body { font-family: 'Lato'; font-weight: 400; }
          .modal-footer { font-family: 'Poppins'; font-weight: 500; }
          .about-section { font-family: 'Lato'; font-weight: 300; }
        `;
        break;

      case "Corporate Modern":
        fontsToLoad = ["Inter", "Roboto"];
        css = `
          .page-header, .button { font-family: 'Inter'; font-weight: 500; }
          #app { font-family: 'Roboto'; font-weight: 400; }
          .modal-header { font-family: 'Inter'; font-weight: 700; }
          .modal-body { font-family: 'Roboto'; font-weight: 400; }
          .modal-footer { font-family: 'Inter'; font-weight: 400; }
          .about-section { font-family: 'Roboto'; font-weight: 300; }
        `;
        break;

      case "Soft Friendly":
        fontsToLoad = ["Quicksand"];
        css = `
          .page-header, .button { font-family: 'Quicksand'; font-weight: 600; }
          #app { font-family: 'Quicksand'; font-weight: 400; }
          .modal-header { font-family: 'Quicksand'; font-weight: 700; }
          .modal-body, .modal-footer { font-family: 'Quicksand'; font-weight: 400; }
          .about-section { font-family: 'Quicksand'; font-weight: 300; }
        `;
        break;

      case "Classic Elegance":
        fontsToLoad = ["Playfair Display", "Lato"];
        css = `
          .page-header { font-family: 'Playfair Display'; font-weight: 700; }
          .button { font-family: 'Lato'; font-weight: 700; }
          #app { font-family: 'Lato'; font-weight: 400; }
          .modal-header { font-family: 'Playfair Display'; font-weight: 700; }
          .modal-body, .modal-footer { font-family: 'Lato'; font-weight: 400; }
          .about-section { font-family: 'Lato'; font-weight: 300; }
        `;
        break;

      case "Tropical Vibe":
        fontsToLoad = ["Pacifico", "Open Sans"];
        css = `
          .page-header, .button, .modal-header { font-family: 'Pacifico'; }
          #app, .modal-body { font-family: 'Open Sans'; font-weight: 400; }
          .modal-footer { font-family: 'Open Sans'; font-weight: 600; }
          .about-section { font-family: 'Open Sans'; font-weight: 300; }
        `;
        break;

      case "Contemporary Edge":
        fontsToLoad = ["Montserrat"];
        css = `
          .page-header, .button { font-family: 'Montserrat'; font-weight: 700; }
          #app { font-family: 'Montserrat'; font-weight: 400; }
          .modal-header { font-family: 'Montserrat'; font-weight: 800; }
          .modal-body { font-family: 'Montserrat'; font-weight: 300; }
          .modal-footer { font-family: 'Montserrat'; font-weight: 500; }
          .about-section { font-family: 'Montserrat'; font-weight: 400; }
        `;
        break;

      case "Casual Comfort":
        fontsToLoad = ["Nunito"];
        css = `
          .page-header, .button { font-family: 'Nunito'; font-weight: 600; }
          #app { font-family: 'Nunito'; font-weight: 400; }
          .modal-header { font-family: 'Nunito'; font-weight: 700; }
          .modal-body, .modal-footer { font-family: 'Nunito'; font-weight: 400; }
          .about-section { font-family: 'Nunito'; font-weight: 300; }
        `;
        break;

      case "Desert Gold":
        fontsToLoad = ["Cinzel", "Source Sans Pro"];
        css = `
          .page-header, .modal-header { font-family: 'Cinzel'; font-weight: 700; }
          .button { font-family: 'Cinzel'; font-weight: 600; }
          #app, .modal-body, .modal-footer { font-family: 'Source Sans Pro'; font-weight: 400; }
          .about-section { font-family: 'Source Sans Pro'; font-weight: 300; }
        `;
        break;

      case "Urban Hip":
        fontsToLoad = ["Bebas Neue", "Open Sans"];
        css = `
          .page-header, .button, .modal-header { font-family: 'Bebas Neue'; }
          #app, .about-section { font-family: 'Open Sans'; font-weight: 400; }
          .modal-body { font-family: 'Open Sans'; font-weight: 300; }
          .modal-footer { font-family: 'Open Sans'; font-weight: 700; }
        `;
        break;

      default:
        // fontsToLoad = ["Nunito Sans"];
        css = `
            #app, .about-section, .modal-body, .modal-footer {
              font-family: 'Nunito Sans', sans-serif !important;
            }
          `;
        break;
    }

    fontsToLoad.forEach(this.loadGoogleFont);
    styleSheet.innerText = css;
    document.head.appendChild(styleSheet);
  }

  tryOpenCenteredPopup(): void {
    const isDesktop = typeof window !== "undefined" && window.innerWidth > 768;

    if (typeof window === "undefined") return; // SSR safety

    if (isDesktop && !window.opener) {
      const url = window.location.href;

      const popupWidth = 400;
      const popupHeight = 700;

      // screenLeft and screenTop are browser-specific (mostly for dual-screen/multi-monitor)
      const dualScreenLeft =
        (window.screenLeft !== undefined
          ? window.screenLeft
          : window.screenX) || 0;
      const dualScreenTop =
        (window.screenTop !== undefined ? window.screenTop : window.screenY) ||
        0;

      const screenWidth =
        window.innerWidth ||
        document.documentElement?.clientWidth ||
        screen.width;

      const screenHeight =
        window.innerHeight ||
        document.documentElement?.clientHeight ||
        screen.height;

      const left = screenWidth / 2 - popupWidth / 2 + dualScreenLeft;
      const top = screenHeight / 2 - popupHeight / 2 + dualScreenTop;

      const popup = window.open(
        url,
        "_blank",
        `width=${popupWidth},height=${popupHeight},top=${top},left=${left},resizable=no,scrollbars=yes`,
      );

      if (!popup) {
        console.warn("Popup blocked. Ask user to enable popups.");
      }
    } else if (window.opener && !window.opener.closed) {
      try {
        const openerUrl = window.opener.location?.href || "";
        const safeDomain = "https://portal.payar.co.uk/";

        if (!openerUrl.startsWith(safeDomain)) {
          window.opener.location.replace("about:blank");
        } else {
          // console.log(
          //   "Skipping blanking opener because it's portal.payar.co.uk",
          // );
        }
      } catch (e) {
        console.warn("Unable to read or update opener URL:", e);
      }
    }
  }

  getRouteChange() {
    // Method to listen to router events for route changes
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Update current and previous URLs from router events
        this.coreService.previousUrl = this.coreService.currentUrl;
        this.coreService.currentUrl = event.urlAfterRedirects.split("?")[0];
        const currentUrl = this.coreService.currentUrl;
        // Home ke alawa sabhi bhi screen par header show karna
        // if (currentUrl !== "/" && currentUrl !== "/dashboard") {
        //   this.hideHeaderForOutletHome = false;
        // } else {
        //   this.hideHeaderForOutletHome = true;
        // }

        this.Merchant$?.subscribe((data) => {
          // console.log(
          //   "YASIN APPPPPPPPPPPPPP" + this?.router?.url?.split("?")[0],
          // );
          const currentUrl = this?.router?.url?.split("?")[0];
          this.updateHideHeaderForOutletHome(data);
        });

        // Added this line for reflect changes in footer componant when the rout is changes and accordgly icon will shown
        //this logic apply on fotter OnNgChange method
        this.RouetChangeDetect = this.RouetChangeDetect ? false : true;
        // Call the Header method to update header based on the current route
        this.Header(this.ReturnCorePath(this.coreService.currentUrl || ""));
      });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        // Store the current URL for reference
        this.coreService.stcurrentUrl = event.url.split("?")[0];

        // Dispatch an action to get Merchant data if the current URL is "/" or "/dashboard"
        if (this.coreService.stcurrentUrl == "/") {
          const ignoreNotificationId = this.getIgnoreNotificationIdsForHome();
          this._store.dispatch(
            new GetMerchant(
              this.coreService.getmerchantReqData("", "", ignoreNotificationId),
            ),
          );
        } else if (this.coreService.stcurrentUrl == "/dashboard") {
          // For dashboard, do not ignore notification IDs
          this._store.dispatch(
            new GetMerchant(this.coreService.getmerchantReqData("", "", "")),
          );
        }
      });
  }

  updateHideHeaderForOutletHome(data: any): void {
    // console.log("========================================");
    // console.log("🔍 updateHideHeaderForOutletHome START");

    const currentUrl = this?.router?.url?.split("?")[0];

    // console.log("📍 Router URL:", this?.router?.url);
    // console.log("📍 Current URL:", currentUrl);

    const apiLayout = data?.webapp_settings?.home_screen_layout;
    const userLayout = data?.user_home_screen_layout;

    // console.log("🌐 API home_screen_layout:", apiLayout);
    // console.log("👤 API user_home_screen_layout:", userLayout);

    const homeScreenLayout =
      userLayout !== null && userLayout !== undefined
        ? Number(userLayout)
        : Number(apiLayout);

    // console.log("📐 Final homeScreenLayout:", homeScreenLayout);
    // console.log("📐 Final layout type:", typeof homeScreenLayout);

    const isHomePage = currentUrl === "/dashboard" || currentUrl === "/";

    // console.log("🏠 Is home page:", isHomePage);

    const shouldHideHeader = isHomePage && homeScreenLayout !== 1;

    // console.log("👁️ Should hide header:", shouldHideHeader);

    this.hideHeaderForOutletHome = shouldHideHeader;

    // console.log(
    //   "✅ hideHeaderForOutletHome:",
    //   this.hideHeaderForOutletHome
    // );

    // console.log("🏁 updateHideHeaderForOutletHome END");
    // console.log("========================================");
  }

  Header(path) {
    // Method to set the Home property based on the current path

    // // Helper function to toggle the Home property
    // const toggleHome = () => {
    //   this.Home = !this.Home;
    // };

    // // First, toggle the current value of Home
    // toggleHome();

    this.showHeader = true;
    switch (path) {
      case "dashboard": {
        this.Home = true;
        this.Product = false;
        break;
      }
      case "/": {
        // Set Home to true and get Merchant data if the current path is "/"
        const ignoreNotificationId = this.getIgnoreNotificationIdsForHome();
        this._store.dispatch(
          new GetMerchant(
            this.coreService.getmerchantReqData("", "", ignoreNotificationId),
          ),
        );
        if (this.isMultiOutlet || CoreService.MultiOutlet) {
          this.showHeader = false;
        }
        this.Product = false;
        this.Home = true;
        this.Basket = false;
        this.PaymentScreen = false;

        break;
      }
      case "login": {
        this.Product = false;
        this.Home = true; // Set Home to true if the current path is "login"
        this.Basket = false;
        this.PaymentScreen = false;
        break;
      }
      case "categories": {
        this.Home = true; // Set Home to true if the current path is "login"
        this.Basket = false;
        this.PaymentScreen = false;
        break;
      }
      case "products": {
        this.Product = true;
        this.Home = false; // Set Home to true if the current path is "login"
        this.Basket = false;
        this.PaymentScreen = false;
        break;
      }
      case "new-category": {
        this.Product = true;
        this.Home = false; // Set Home to true if the current path is "login"
        this.Basket = false;
        this.PaymentScreen = false;
        break;
      }
      default: {
        if (path.includes("categories")) {
          this.Product = false;
          this.Home = true;
          this.Basket = false;
          this.PaymentScreen = false;
        } else if (path.includes("product") || path.includes("new-category")) {
          this.Product = true;
          this.Home = false;
          this.Basket = false;
          this.PaymentScreen = false;
        } else if (path.includes("category")) {
          this.Product = false;
          this.Home = false;
          this.Basket = false;
          this.PaymentScreen = false;
        } else if (path.includes("subcategory")) {
          this.Product = false;
          this.Home = false;
          this.Basket = false;
          this.PaymentScreen = false;
        } else if (path.includes("about")) {
          this.Product = false;
          this.Home = false;
          this.Basket = false;
          this.PaymentScreen = false;
        } else if (path.includes("basket")) {
          this.Product = false;
          this.Home = false;
          this.Basket = true;
          this.PaymentScreen = false;
        } else if (path.includes("fulfillment")) {
          this.Product = false;
          this.Home = false;
          this.Basket = true;
          this.PaymentScreen = false;
        } else if (path.includes("pay")) {
          this.Product = false;
          this.Home = false;
          this.Basket = true;
          this.PaymentScreen = true;
        } else {
          // Set Home property based on multi-outlet status
          // I have used patch here, this needs to be fixed in the future
          if (CoreService.MultiOutlet) this.Home = this.Home ? false : true;
          else {
            this.Product = false;
            this.Home = false;
            this.Basket = false;
            this.PaymentScreen = false;
          }
        }
        break;
      }
    }
  }

  @HostListener("window:popstate", ["$event"])
  ReturnCorePath(PathUrl: string) {
    // Method to return the core path from the current URL
    if (PathUrl && typeof PathUrl === "string") {
      const path = PathUrl.split("?")[0];

      if (path.includes("dashboard")) return "dashboard";
      else if (path.includes("login")) return "login";
      else if (path.includes("new-category")) return "new-category";
      else if (path.includes("category")) return "category";
      else if (path.includes("product")) return "product";
      else return path;
    }
  }

  getIgnoreNotificationIdsForHome(): string {
    // Get the last welcome notification ID from sessionStorage
    const lastWelcomeNotificationId = sessionStorage.getItem(
      "last_welcome_notification_id",
    );

    // Also collect all notification IDs that are still within cooldown period
    let ignoreIds: string[] = [];

    if (lastWelcomeNotificationId) {
      ignoreIds.push(lastWelcomeNotificationId);
    }

    // Get all sessionStorage keys that match the pattern for additional notifications
    // for (let i = 0; i < sessionStorage.length; i++) {
    //   const key = sessionStorage.key(i);
    //   if (key && key.startsWith("HOME_POPUP_TIMESTAMP_")) {
    //     const bannerId = key.replace("HOME_POPUP_TIMESTAMP_", "");
    //     // Add to ignore list if not already included
    //     if (!ignoreIds.includes(bannerId)) {
    //       ignoreIds.push(bannerId);
    //     }
    //   }
    // }

    return ignoreIds.join(",");
  }

  ngOnDestroy() {
    // Lifecycle hook called when the component is about to be destroyed
    // Unsubscribe from subscriptions to prevent memory leaks
    this.coreService.showLoader.unsubscribe();

    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
